import React, { useState } from "react"
import { Link } from "gatsby"


export default function masthead({ title, subheader, moreinfoTitle, moreinfoUrl, devBanner, typeLanding}) {



  let devBannerRequired
  let moreInfoContent
  let pageClass
  let pageStyle
  let pageImage

// This is a really bad hack
if (!process.env.BROWSER) {
  global.window = {}; // Temporarily define window for server-side
}
if (typeof window !== 'undefined') {
  if (window.location.href.indexOf("principles") > -1) {pageImage = require('@images/navigation/principlespage.png');}
  else if (window.location.href.indexOf("components") > -1) {pageImage = require('@images/navigation/componentspage.png');}
  else if (window.location.href.indexOf("patterns") > -1) {pageImage = require('@images/navigation/patternspage.png');}
  else if (window.location.href.indexOf("tools") > -1) {pageImage = require('@images/navigation/toolspage.png');}
  else if (window.location.href.indexOf("foundations") > -1) {pageImage = require('@images/navigation/foundationspage.png');}
}


if (typeLanding) {
  pageClass = "priPag"
  pageStyle = {backgroundImage: `url(${pageImage})`}
}
else {
  pageClass = ""
  pageStyle = null
}

if (moreinfoUrl) {
  moreInfoContent = <p className="introPara">For information, see our <Link to={moreinfoUrl}>{moreinfoTitle} page</Link></p>
}
if (devBanner)
{
  devBannerRequired = <div className="tooltip betaBanner">Development Required
            <span className="tooltiptext">Please be advised, development for this piece is still required.</span>
          </div>
}
  return (
    <div className={pageClass + ' mh-ttl'} style={pageStyle}>

      <section className="docs segment vertical masthead">
        {devBannerRequired}
        <h1 className="docs header">
          {title}
          <p className="introPara">{subheader}</p>
          {moreInfoContent}
        </h1>
      </section>
    </div>
  )


}